import { tokenize } from "linkifyjs";
import type { ReactNode } from "react";
import { blockContentStyles } from "../design-system/components/BlockContent/blockContent.css";

/**
 * Splits text into strings and links for any URLs in it. Line breaks are left
 * to the container's CSS: give it `preLine` from `./text.css`.
 */
export const linkify = (
  text: string,
  linkClassName: string = blockContentStyles.link,
): ReactNode[] =>
  tokenize(text).map((t, i) =>
    t.t === "url" ? (
      // Index keys are fine: the list is derived from the text alone.
      <a
        key={i}
        className={linkClassName}
        href={t.toHref("https")}
        target="_blank"
        rel="noreferrer"
      >
        {t.v}
      </a>
    ) : (
      t.v
    ),
  );
